@use '~/theme/theme' as *;

.transactionSummary {
  @include border-radius(sm);

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: spacing(1.5);
  gap: spacing(2);
  background: color(grey-100);

  &:global {
    &.isReconciled {
      background: color(green-200);
    }
  }
}

.transactionInfo {
  flex: 1;
  display: flex;
  flex-direction: row;
  min-width: 0;
  gap: spacing(4);
}

.transactionInfoColumnDescription {
  flex: 2;
}

.modalContent {
  gap: spacing(2);
  flex-shrink: 1;
}

.modal {
  width: 960px;
}

.associatedInvoices {
  margin-top: 16px;
  margin-bottom: 16px;
  margin-left: 30px;
}

.actionsNotOpen {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.actionsWithAssociated {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.actionsConfirm {
  display: flex;
  justify-content: flex-end;
}

.totalToBeReconciled {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: spacing(2);
}

.remainingAmount {
  min-width: 100px;
}

.confirm {
  display: flex;
  gap: spacing(5);
  align-items: center;
  margin-left: auto;
}

.isReconciled {
  color: color(green-800);
}
